<template>
  <header
    v-if="!isWebview"
    v-analytics-module="{ name: 'main-menu', position: 'header' }"
  >
    <MemberBanner />
    <nav-bar
      :profile="profile"
      @skipToMainContent="skipToMainContent"
      @skipToFooterContent="skipToFooterContent"
    />
    <house-board v-if="hasProfile" />
    <profile-menu v-if="hasProfile" />
  </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import NavBar from '~/components/nav-bar/NavBar'
import HouseBoard from '~/components/house-board'
import ProfileMenu from '~/components/profile-menu'
import MemberBanner from '~/components/member-banner'
import isEmptyObject from '~/helpers/is-empty-object'

const { mapGetters: mapProfileGetters } = createNamespacedHelpers('user/profile')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'sh-header',

  components: {
    NavBar,
    HouseBoard,
    MemberBanner,
    ProfileMenu
  },

  computed: {
    ...mapProfileGetters(['profile']),
    ...mapEnvGetters(['isWebview']),

    hasProfile () {
      return this.profile && !isEmptyObject(this.profile)
    }
  },

  methods: {
    skipToMainContent () {
      this.$emit('skipToMainContent')
    },

    skipToFooterContent () {
      this.$emit('skipToFooterContent')
    }
  }
}
</script>

<style>

</style>
